const orcamentosChart1 = {
    series: [{
        name: 'Concluído Tasks',
        type: 'column',
        data: [23, 11, 22, 27, 13, 22, 52, 21, 44, 22, 30]
    },
        {
            name: 'All Tasks',
            type: 'column',
            data: [23, 11, 34, 27, 17, 22, 62, 32, 44, 22, 39]
        }],
    chartOptions: {
        chart: {
            stacked: false,
            toolbar: {
                show: false,
            }
        },
        dataLabels: {
            enabled: false
        },
        stroke: {
            width: 2,
            curve: 'smooth'
        },
        plotOptions: {
            bar: {
                columnWidth: '20%',
                endingShape: 'rounded'
            }
        },
        colors: ['#556ee6', '#34c38f'],
        fill: {
            gradient: {
                inverseColors: false,
                shade: 'light',
                type: "vertical",
                opacityFrom: 0.85,
                opacityTo: 0.55,
                stops: [0, 100, 100, 100]
            }
        },
        labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov'],
        markers: {
            size: 0
        },
        yaxis: {
            min: 0
        },
    }
};


const tasksChart = {
    series: [{
        name: 'Concluído',
        type: 'column',
        data: [23, 11, 22, 27, 13, 22]
    },
    {
        name: 'Todos',
        type: 'column',
        data: [23, 11, 34, 27, 17, 22]
    }],
    chartOptions: {
        chart: {
            stacked: false,
            toolbar: {
                show: false,
            }
        },
        dataLabels: {
            enabled: false
        },
        stroke: {
            width: 2,
            curve: 'smooth'
        },
        plotOptions: {
            bar: {
                columnWidth: '20%',
                endingShape: 'rounded'
            }
        },
        colors: ['#556ee6', '#34c38f'],
        fill: {
            gradient: {
                inverseColors: false,
                shade: 'light',
                type: "vertical",
                opacityFrom: 0.85,
                opacityTo: 0.55,
                stops: [0, 100, 100, 100]
            }
        },
        labels: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun'],
        markers: {
            size: 0
        },
        yaxis: {
            min: 0
        },
    }
};

const tasks = [
    {
        index: 1,
        taskType: 'upcoming',
        name: 'Criar novo dashboard',
        images: [require('@/assets/images/users/avatar-2.jpg'), require('@/assets/images/users/avatar-1.jpg')],
        status: 'Atraso',
        checked: false
    },
    {
        index: 2,
        taskType: 'upcoming',
        name: 'Validação novo campo integração ERP',
        images: [require('@/assets/images/users/avatar-4.jpg'), require('@/assets/images/users/avatar-5.jpg')],
        status: 'Aprovado',
        checked: true
    },
    {
        index: 3,
        taskType: 'upcoming',
        name: 'Validação nova regra comercial',
        images: [require('@/assets/images/users/avatar-1.jpg')],
        status: 'Atraso',
        checked: false
    },
    {
        index: 4,
        taskType: 'inprogress',
        name: 'Faturamento pedido 000888 - R$ 15.488,00',
        images: [require('@/assets/images/users/avatar-7.jpg')],
        status: 'Concluído',
        checked: true
    },
    {
        index: 5,
        taskType: 'inprogress',
        name: 'Faturamento pedido 000887 - R$ 401.876,00',
        images: [require('@/assets/images/users/avatar-8.jpg'), require('@/assets/images/users/avatar-1.jpg')],
        status: 'Pendente',
        checked: false
    },
    {
        index: 6,
        taskType: 'Concluídod',
        name: 'Projeto Testes 0008',
        images: [require('@/assets/images/users/avatar-6.jpg')],
        status: 'Concluído',
        checked: false
    },
    {
        index: 7,
        taskType: 'Concluídod',
        name: 'Projeto Testes 0009',
        images: [require('@/assets/images/users/avatar-7.jpg')],
        status: 'Concluído',
        checked: true
    },
    {
        index: 8,
        taskType: 'Concluídod',
        name: 'Projeto Testes 0999',
        images: [require('@/assets/images/users/avatar-4.jpg'), require('@/assets/images/users/avatar-2.jpg')],
        status: 'Concluído',
        checked: false
    }
];



export { tasksChart, tasks, orcamentosChart1 };
